
document.addEventListener("DOMContentLoaded", function() {
  function addReturnToCartButton() {
    const target = document.getElementById("aod_smart_cart_saver");
    if (target && !document.querySelector(".ctm-return-to-cart")) {
      const wrapper = document.createElement("div");
      wrapper.className = "ctm-return-to-cart";

      const button = document.createElement("button");
      button.type = "button";
      button.name = "return";
      button.value = "return to cart";
      button.className = "c-btn c-btn--primary";
      button.textContent = "Return to Cart";

      // Redirect on click
      button.addEventListener("click", function() {
        window.location.href = "https://www.blindsdownunder.com.au/cart";
      });

      wrapper.appendChild(button);
      target.appendChild(wrapper);
    }
  }

  // Handle dynamic loading of app content
  const observer = new MutationObserver(addReturnToCartButton);
  observer.observe(document.body, { childList: true, subtree: true });

  // Run once immediately
  addReturnToCartButton();
});

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.aod-save-cart-button, .aod-view-cart-button');
  const loader = document.getElementById('aod_loader');

  if (buttons.length && loader) {
    buttons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        // Show the full-page loader
        loader.classList.remove('DisplayNone');

         //Keep loader visible for 10 second (1000ms)
        setTimeout(() => {
          loader.classList.add('DisplayNone');
        }, 10000);
      });
    });
  }
});



